module.exports = __webpack_public_path__ + "img/fas-sync-alt.e3aaff91.svg";